import { Helmet } from "react-helmet-async"
import { TripHoldingEmail } from "../../../../../Trips"
import { useTripDetailsOutletContext } from "../_trip-details-context"

export default function TripHoldingEmailPage() {
	const { trip, hasChangesBetweenQuoteAndBookings } =
		useTripDetailsOutletContext()
	return (
		<>
			<Helmet>
				<title>Trip Holding Email Docs</title>
			</Helmet>
			<TripHoldingEmail
				trip={trip}
				disabledSharing={hasChangesBetweenQuoteAndBookings}
			/>
		</>
	)
}
